var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-shape-dialog',{attrs:{"title":_vm._f("i18n")('house.param.floorShape.title'),"subtitle":_vm._f("i18n")('house.param.floorShape.subtitle'),"description":_vm._f("i18n")('house.param.floorShape.description')},model:{value:(_vm.shape),callback:function ($$v) {_vm.shape=$$v},expression:"shape"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abf37c5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/HouseShapeDialog.vue
// module id = null
// module chunks = 